import Img from './components/Img';
import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-left">
        <Img src="/assets/atomic-tattoo-removal-logo.png" alt="Atomic Tattoo Removal Logo" className="header-logo" />
      </div>
      <div className="header-right">
        Now Open in Wrentham, MA
      </div>
    </header>
  );
};

export default Header;